import { buildImageUrl } from '@zero/shared';

/**
 * Build a COS thumbnail URL for small image displays. Pass the max CSS
 * dimension in pixels; this multiplies by 2 (for HiDPI) and asks COS to
 * return a resized version. Cuts page weight dramatically when rendering
 * many tiles at once (e.g. resource grids, record outputs, pickers).
 */
export function thumb(url: string | null | undefined, sizePx: number): string {
  if (!url) return '';
  const target = Math.max(32, Math.round(sizePx * 2));
  return buildImageUrl(url, { w: target, h: target, q: 80 });
}
